import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer, SuiCollapsible } from '@splashthat/sui';

import { isFormTypeTicketSale } from 'common/entities/form/selectors';
import RichTextLabelControl from './components/RichTextLabelControl';
import ReservedNodeIndication from './components/ReservedNodeIndication';
import { getEditFormNodeId, getEditFormNode, getFormId } from '../../selectors';
import getReservedInputNameLabel from '../../utils/getReservedInputNameLabel';
import PlaceholderTextControl from './components/PlaceholderTextControl';
import SectionSeparator from './components/SectionSeparator';
import UrlParamControl from './components/UrlParamControl';
import EditViewSectionContainer from './EditViewSectionContainer';

const ADVANCED_COLLAPSIBLE_HEADER = 'Advanced';

const getTooltipContent = (label) => `You may modify the label of this question.
RSVP answers will appear in the "${label}" column of the guest list`;

/**
 * Component for main guest information fields like first name, last name and email.
 */
const EditQuestionGuestInfoField = ({ formNodeId, name, showUrlParamControl }) => (
    <React.Fragment>
        <EditViewSectionContainer>
            <SuiContainer variation="flex-group">
                <RichTextLabelControl formNodeId={formNodeId} />
                <ReservedNodeIndication
                    label={getReservedInputNameLabel(name)}
                    tooltip={getTooltipContent(getReservedInputNameLabel(name))}
                />
            </SuiContainer>

            <SectionSeparator />

            <SuiContainer variation="flex-group">
                <PlaceholderTextControl formNodeId={formNodeId} />
            </SuiContainer>
        </EditViewSectionContainer>
        {showUrlParamControl && (
            <SuiCollapsible
                fullWidth
                header={ADVANCED_COLLAPSIBLE_HEADER}
                content={
                    <EditViewSectionContainer>
                        <UrlParamControl formNodeId={formNodeId} />
                    </EditViewSectionContainer>
                }
            />
        )}
    </React.Fragment>
);

EditQuestionGuestInfoField.propTypes = {
    name: PropTypes.string.isRequired,
    formNodeId: PropTypes.string.isRequired,
    showUrlParamControl: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const node = getEditFormNode(state);
    const formNodeId = getEditFormNodeId(state);
    const showUrlParamControl = !isFormTypeTicketSale(state, getFormId(state));
    return {
        formNodeId,
        name: node ? node.name : undefined,
        showUrlParamControl,
    };
};

export default connect(mapStateToProps)(EditQuestionGuestInfoField);
